import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { EnvironmentService } from "../environment.service";
import { ITagModel, ITagModels, ITagPostTagsToProductRequestModel, ITagPostTagsToProductResponseModel, ITagPostRequestModel, ITagPostAndPutResponseModel, 
         ITagDeleteResponseModel, ITagPutRequestModel, ITagType } from "../../models/product/dto/tags/product-tags.model";
import { ApplicationContextService } from "../application-context.service";

@Injectable({
    providedIn: 'root'
})
export class ProductTagsService {
    fullPath: string;
    languageCode: string;
    unsavedChangesOnTagsTab = new BehaviorSubject<boolean | undefined>(undefined);
    unsavedChangesOnTagsTabObs = this.unsavedChangesOnTagsTab.asObservable();

    constructor(private readonly httpClient: HttpClient, public envService: EnvironmentService, private applicationContextService: ApplicationContextService) {
        this.fullPath = `${envService.settings.apiUrl}`;
        this.languageCode = this.applicationContextService.getLanguageCodeFromUrl().toUpperCase();
    }

    public getAllTagsForProduct(productId: number): Observable<ITagModels> {
        return this.httpClient.get<ITagModels>(`${this.fullPath}/Products/${productId}/tags?languageCode=${this.languageCode}`);
    } 

    public search(query: string): Observable<ITagModels> {
        return this.httpClient.get<ITagModels>(`${this.fullPath}/ProductTags/SearchTagByName?name=${query}`);
    }

    public assignTagsToProduct(model: ITagPostTagsToProductRequestModel): Observable<ITagPostTagsToProductResponseModel> {
        return this.httpClient.post<ITagPostTagsToProductResponseModel>(`${this.fullPath}/Products/${model.productId}/tags`, model);
    }

    public getTagTypes(): Observable<ITagType[]> {
        return this.httpClient.get<ITagType[]>(`${this.fullPath}/Options/tagTypes`);
    }

    public createTag(model: ITagPostRequestModel): Observable<ITagPostAndPutResponseModel> {
        return this.httpClient.post<ITagPostAndPutResponseModel>(`${this.fullPath}/ProductTags`, model);
    }

    public deleteTag(id: number): Observable<ITagDeleteResponseModel> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: {
                id: id
            }
        };

        return this.httpClient.delete<ITagDeleteResponseModel>(`${this.fullPath}/ProductTags/DeleteTag/${id}`, httpOptions);
    }

    public getTagById(tagId: number): Observable<ITagModel> {
        return this.httpClient.get<ITagModel>(`${this.fullPath}/ProductTags/GetTagById/${tagId}`);
    }

    public editTag(model: ITagPutRequestModel): Observable<ITagPostAndPutResponseModel> {
        return this.httpClient.put<ITagPostAndPutResponseModel>(`${this.fullPath}/ProductTags/${model.id}/tags`, model);
    }

    setUnsavedChangesOnTagsTabStatus(unsavedChanges: boolean) {
        this.unsavedChangesOnTagsTab.next(unsavedChanges);
    }
}